import React from 'react';
import { Row, Col } from 'react-bootstrap';

const Footer = () => {
  return (
    <footer>
      <Row>
        <Col md={4}>
          <img className="footer-logo" src={require('../../images/logo.png')} />
        </Col>
        <Col md={4}>
          <div style={{ textAlign: 'center' }}>Version 5.1.6</div>
        </Col>
        <Col md={4}>
          <a href="mailto:support@cognomos.com" className="pull-right">
            support@cognomos.com
          </a>
        </Col>
      </Row>
    </footer>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/common/Footer.js